import api from "../../API/apiConfig";

// 1. Lấy danh sách Email Templates
export const getEmailTemplates = (filter) => {
  return api.get(`/email/list-template`, {params: filter});
};

// 2. Thêm mới EmailTemplate
export const addEmailTemplate = (emailTemplateData) => {
  return api.post("/email/create-template", emailTemplateData);
};

// 3. Cập nhật EmailTemplate theo ID
export const updateEmailTemplate = (id, emailTemplateData) => {
  return api.put(`/email/update-template/${id}`, emailTemplateData);
};

// 4. Xóa EmailTemplate theo ID
export const deleteEmailTemplate = (id) => {
  return api.delete(`/email/delete-template/${id}`);
};

// 5. Xem chi tiết một EmailTemplate theo ID
export const getEmailTemplateDetail = (id) => {
  return api.get(`/email/detail-template/${id}`);
};